export default "__VITE_ASSET__NNNkfhCv__"